import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  class: "text-center"
};
const _hoisted_2 = {
  class: "my-4 gradient-text"
};
const _hoisted_3 = {
  class: "text-muted"
};
const _hoisted_4 = {
  key: 0,
  class: "text-muted"
};
const _hoisted_5 = {
  key: 1,
  class: "gradient-text"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  class: "ri-spam-line me-1",
  style: {
    "vertical-align": "bottom"
  }
}, null, -1);
const _hoisted_7 = {
  class: "d-inline-flex"
};
const _hoisted_8 = {
  id: "pills-tab",
  class: "nav nav-pills arrow-navtabs plan-nav rounded mb-3 p-1",
  role: "tablist"
};
const _hoisted_9 = {
  class: "nav-item",
  role: "presentation"
};
const _hoisted_10 = {
  class: "nav-item",
  role: "presentation"
};
const _hoisted_11 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center",
  style: {
    "min-height": "350px"
  }
};
const _hoisted_12 = {
  class: "d-flex justify-content-center mb-3"
};
const _hoisted_13 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center",
  style: {
    "min-height": "350px"
  }
};
const _hoisted_14 = {
  class: "text-center"
};
const _hoisted_15 = {
  class: "mt-2"
};
const _hoisted_16 = {
  class: "text-center"
};
const _hoisted_17 = {
  class: "mb-2 gradient-text"
};
const _hoisted_18 = {
  class: "text-muted mb-0",
  style: {
    "min-height": "40px"
  }
};
const _hoisted_19 = {
  class: "pt-4 text-center mb-3 border-bottom"
};
const _hoisted_20 = {
  class: "gradient-text"
};
const _hoisted_21 = {
  class: "fs-13 text-muted text-capitalize"
};
const _hoisted_22 = {
  class: "list-unstyled text-muted vstack gap-1"
};
const _hoisted_23 = {
  class: "d-flex"
};
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", {
  class: "ri-check-line fs-20 align-middle me-3"
}, null, -1);
const _hoisted_25 = {
  class: "mb-2"
};
const _hoisted_26 = {
  class: "d-flex"
};
const _hoisted_27 = {
  class: "mt-4"
};
import { computed, ref } from 'vue';
import usePlanPrice from '@/composable/plan-price';
import { ElLoading } from 'element-plus';
import generateDynamicId from '@/composable/createDynamicId';
import { useStore } from 'vuex';
import i18n from '@/i18n';
export default {
  __name: 'plan-pricing',
  setup(__props) {
    const store = useStore();
    const hasPermissions = computed(() => permission => {
      return store.getters['auth/hasPermission'](permission);
    });
    const {
      isOpenPlanPriceDialog,
      plans,
      subscribePlan,
      hasPendingRequest,
      setPlanPriceDialog,
      fetchPlans
    } = usePlanPrice();
    const isLoading = ref(false);
    const canSeeSuccessModel = ref(false);
    const fullscreenLoading = ref(false);
    const requestedPlanType = ref('monthly');
    const handleChangePlanType = type => {
      requestedPlanType.value = type;
    };
    const havePlan = (codeToCheck, arrayOfObjects) => {
      if (!arrayOfObjects || arrayOfObjects.length === 0) return false;
      return arrayOfObjects.some(obj => obj?.code === codeToCheck);
    };
    const getPrice = computed(() => plan => {
      return requestedPlanType.value === 'monthly' ? plan?.monthly_price : plan?.annual_price;
    });
    const features = computed(() => (userLimits, projectLimits) => [{
      id: generateDynamicId(),
      code: 'user_limit',
      name: i18n.global.t('pricing.userLimit'),
      description: i18n.global.t('pricing.userLimitDescription', {
        userLimits: userLimits ?? i18n.global.t('pricing.unlimited')
      })
    }, {
      id: generateDynamicId(),
      code: 'project_limit',
      name: i18n.global.t('pricing.projectLimit'),
      description: i18n.global.t('pricing.projectLimitDescription', {
        projectLimits: projectLimits ?? i18n.global.t('pricing.unlimited')
      })
    }]);
    const handleChoosePlan = async plan => {
      const payload = {
        plan_id: plan.id,
        type: requestedPlanType.value
      };
      const loadingInstance = ElLoading.service({
        lock: true,
        text: i18n.global.t('common.submitting'),
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: 'custom-blur-dark custom-gradient-spinner'
      });
      await subscribePlan(payload).then(async res => {
        window.open(res.checkout_url);
      }).finally(() => {
        loadingInstance.close();
      });
    };
    const getWidth = computed(() => {
      return hasPendingRequest.value || canSeeSuccessModel.value ? '350px' : '90%';
    });
    return (_ctx, _cache) => {
      const _component_BButton = _resolveComponent("BButton");
      const _component_b_spinner = _resolveComponent("b-spinner");
      const _component_b_button = _resolveComponent("b-button");
      const _component_BCardBody = _resolveComponent("BCardBody");
      const _component_BCard = _resolveComponent("BCard");
      const _component_BCol = _resolveComponent("BCol");
      const _component_BRow = _resolveComponent("BRow");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        modelValue: _unref(isOpenPlanPriceDialog),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(isOpenPlanPriceDialog) ? isOpenPlanPriceDialog.value = $event : null),
        "close-on-click-modal": true,
        "show-close": false,
        width: getWidth.value,
        class: "my-2"
      }, _createSlots({
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h2", _hoisted_2, [_createElementVNode("strong", null, _toDisplayString(_ctx.$t('pricing.plansAndPricing')), 1)]), _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('pricing.simplePricing')), 1), hasPermissions.value('subscription-create-request') ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('pricing.choosePlan')), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createTextVNode(_toDisplayString(_ctx.$t('pricing.contactAdmin')), 1)])), _createElementVNode("div", _hoisted_7, [_createElementVNode("ul", _hoisted_8, [_createElementVNode("li", _hoisted_9, [_createVNode(_component_BButton, {
          id: "month-tab",
          "aria-selected": "true",
          class: "nav-link fw-semibold active",
          "data-bs-target": "#month",
          "data-bs-toggle": "pill",
          role: "tab",
          type: "button",
          variant: "link",
          onClick: _cache[0] || (_cache[0] = $event => handleChangePlanType('monthly'))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('enums.monthly')), 1)]),
          _: 1
        })]), _createElementVNode("li", _hoisted_10, [_createVNode(_component_BButton, {
          id: "annual-tab",
          "aria-selected": "false",
          class: "nav-link fw-semibold",
          "data-bs-target": "#annual",
          "data-bs-toggle": "pill",
          role: "tab",
          type: "button",
          variant: "link",
          onClick: _cache[1] || (_cache[1] = $event => handleChangePlanType('annual'))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('pricing.annually')), 1)]),
          _: 1
        })])])])])]),
        _: 2
      }, [!_unref(hasPendingRequest) && !canSeeSuccessModel.value ? {
        name: "default",
        fn: _withCtx(() => [isLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_b_spinner, {
          class: "d-block mx-auto",
          label: "large Spinning",
          type: "grow",
          variant: "info"
        })])])) : _unref(plans)?.plans?.length < 1 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("h5", _hoisted_15, _toDisplayString(_ctx.$t('common.noData')), 1)])])) : (_openBlock(), _createBlock(_component_BRow, {
          key: 2,
          class: "justify-content-center"
        }, {
          default: _withCtx(() => [_createVNode(_component_BCol, {
            xl: "9"
          }, {
            default: _withCtx(() => [_createVNode(_component_BRow, {
              class: "justify-content-center"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plans).plans, plan => {
                return _openBlock(), _createBlock(_component_BCol, {
                  key: plan.id,
                  lg: "4",
                  sm: "12"
                }, {
                  default: _withCtx(() => [_createVNode(_component_BCard, {
                    class: "pricing-card border",
                    "no-body": ""
                  }, {
                    default: _withCtx(() => [_createVNode(_component_BCardBody, {
                      class: "p-2 m-3"
                    }, {
                      default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createElementVNode("h3", _hoisted_17, [_createElementVNode("strong", null, _toDisplayString(plan?.name ?? ''), 1)]), _createElementVNode("p", _hoisted_18, _toDisplayString(plan?.description ?? ''), 1)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("h2", _hoisted_20, [_createTextVNode(" $" + _toDisplayString(getPrice.value(plan)) + " ", 1), _createElementVNode("span", _hoisted_21, " / " + _toDisplayString(requestedPlanType.value), 1)])]), _createElementVNode("div", null, [_createElementVNode("ul", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(features.value(plan?.user_limit, plan?.project_limit), mainFeature => {
                        return _openBlock(), _createElementBlock("li", {
                          key: mainFeature.id
                        }, [_createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("p", _hoisted_25, [_createElementVNode("strong", null, _toDisplayString(mainFeature.name) + " : ", 1), _createTextVNode(" " + _toDisplayString(mainFeature.description), 1)])])]);
                      }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plans)?.features, feature => {
                        return _openBlock(), _createElementBlock("li", {
                          key: feature.id
                        }, [_createElementVNode("div", _hoisted_26, [_createElementVNode("i", {
                          class: _normalizeClass([havePlan(feature.code, plan.features) ? 'ri-check-line' : 'ri-close-fill ', "fs-20 align-middle me-3"])
                        }, null, 2), _createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(feature.name) + " : ", 1), _createTextVNode(" " + _toDisplayString(feature.description), 1)])])]);
                      }), 128))]), _createElementVNode("div", _hoisted_27, [hasPermissions.value('subscription-create-request') ? _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                        key: 0,
                        disabled: !plan?.can_subscribe,
                        class: "btn w-100 text-white border-0",
                        color: "danger",
                        style: {
                          "background": "linear-gradient(135deg, #f06548, #f79d65, #f0c14b)"
                        },
                        onClick: $event => handleChoosePlan(plan)
                      }, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(plan.code === 'free' ? _ctx.$t('pricing.getStarted') : plan.current_plan ? _ctx.$t('pricing.currentPlan') : _ctx.$t('pricing.choose')), 1)]),
                        _: 2
                      }, 1032, ["disabled", "onClick"])), [[_directive_loading, fullscreenLoading.value, void 0, {
                        fullscreen: true,
                        lock: true
                      }]]) : _createCommentVNode("", true)])])]),
                      _: 2
                    }, 1024)]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1024);
              }), 128))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }))]),
        key: "0"
      } : undefined]), 1032, ["modelValue", "width"])]);
    };
  }
};